



















































import { Component, Vue } from 'vue-property-decorator';
import CommonUtils from '@/utils/common-utils';
import NavbarLanguageSelector from './NavbarLanguageSelector.vue';
import MobileMenu from './MobileMenu.vue';

@Component({
  components: {
    NavbarLanguageSelector,
    MobileMenu
  }
})
export default class AppBar extends Vue {
  $route!: any;
  referrer = '';
  menuOpen = false;

  created() {
    if (CommonUtils.hasText(this.$route.query.referrer)) {
      this.referrer = this.$route.query.referrer;
    } else if (CommonUtils.hasText(sessionStorage.referrer)) {
      this.referrer = sessionStorage.referrer;
    } else if (CommonUtils.hasText(document.referrer)) {
      this.referrer = document.referrer;
    } else {
      this.referrer = 'https://planbook.com';
    }
    if (this.referrer.indexOf('localhost:8080') > -1) {
      this.referrer = 'localhost:8080';
    } else if (this.referrer.indexOf('localhost:8092') > -1) {
      this.referrer = 'localhost:8092';
    } else if (this.referrer.indexOf('planbookbeta.com') > -1) {
      this.referrer = 'https://planbookbeta.com';
    } else if (this.referrer.indexOf('planbook.com') > -1) {
      this.referrer = 'https://planbook.com';
    }
    this.referrer = this.referrer.endsWith('/') ? this.referrer : this.referrer + '/';
  }

  signIn() {
    CommonUtils.doLogin();
  }
}
